import Constants from '@/Constants';
import { RichContentOption } from '@/models/Chat';
import React from 'react';
import * as Icon from 'react-feather';
import './style.scss';

interface Props {
    marked: boolean;
    chipData: RichContentOption;
    onClick?: React.MouseEventHandler<HTMLButtonElement>;
}

const ChatPeriodDay: React.FC<Props> = (props: Props) => {
    const { marked, chipData, onClick } = props;

    const retriveIcon = (label: string) => {
        if (label === Constants.periodOfDay.MORNING) return <Icon.Sunrise />;

        if (label === Constants.periodOfDay.AFTERNOON) return <Icon.Sun />;

        if (label === Constants.periodOfDay.EVENING) return <Icon.Moon />;
    };

    return (
        <div className="time-of-the-day">
            <button className={`btn btn-primary btn-sm btn-time ${marked ? 'is-active' : ''}`} onClick={onClick || (() => {})} type="button">
                <span className="spn-time">{retriveIcon(String(chipData.value))} </span>
                {chipData.text}
            </button>
        </div>
    );
};

export default ChatPeriodDay;
